import { useEffect } from "react";
import { axiosPrivate } from "../utils/axios";
import useAuth from "./useAuth";
import useRefreshToken from "./useRefreshToken";

const useAxios = () => {
  const refresh = useRefreshToken();
  const { session } = useAuth();

  useEffect(() => {
    const requestIntercept = axiosPrivate.interceptors.request.use(
      (config: any) => {
        if (config.headers && !config.headers["Authorization"]) {
          config.headers["Authorization"] = `Bearer ${session?.accessToken}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    const responseIntercept = axiosPrivate.interceptors.response.use(
      (response) => response,
      async (error: any) => {
        const prevRequest = error?.config;
        if (error?.response?.status === 403 && !prevRequest?.sent) {
          prevRequest.sent = true;
          const newAceessToken = await refresh();
          prevRequest.headers["Authorization"] = `Bearer ${newAceessToken}`;
          return axiosPrivate(prevRequest);
        }
        return Promise.reject(error);
      }
    );
    return () => {
      axiosPrivate.interceptors.response.eject(requestIntercept);
      axiosPrivate.interceptors.response.eject(responseIntercept);
    };
  }, [session, refresh]);

  return axiosPrivate;
};

export default useAxios;
